'use client'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { confirmExecutionPlan } from '@/service/execution-plan.api'
import { executionKeys } from '@/service/execution.hook'
import { ConfirmExecutionPlanResponse, DraftExecutionPlan } from '@/types/generated/public_api'
import { ErrorResponse } from '@/types/service'

export const useConfirmExecutionPlan = (props?: {
  onSuccess?: (data: ConfirmExecutionPlanResponse, variables: DraftExecutionPlan) => void
  onError?: (error: ErrorResponse, variables: DraftExecutionPlan) => void
}) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (draft: DraftExecutionPlan) => confirmExecutionPlan(draft),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: executionKeys.all })
      props?.onSuccess?.(data, variables)
    },
    onError: props?.onError,
  })
}
